import { snackbar } from '@flipster/react/design-system/snackbar';
import { css } from '@flipster/styled-system/css';

interface StoreAsTmpButtonProps {
  onClick: () => void;
}

export const StoreAsTmpButton = ({ onClick }: StoreAsTmpButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={css({
        cursor: 'pointer',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'border.default.level-2',
        bgColor: 'background.default.level-0',
        px: 6,
        py: 2,
        rounded: 3,
        textStyle: 'Text/XS/Monospace/Regular',
        color: 'content.default.level-5',
        transition: 'all 0.15s ease',
        _hover: {
          bgColor: 'background.default.level-3',
          borderColor: 'border.default.level-3',
          color: 'inverse.white',
        },
      })}
    >
      Store as{' '}
      <code
        className={css({
          textStyle: 'Text/XS/Monospace/Regular',
          color: 'content.accent.info',
        })}
      >
        window.tmp
      </code>
    </button>
  );
};

export function getStoreAsTmpFn(name: string, value: unknown) {
  return function storeAsTmp() {
    // @ts-ignore
    window.tmp = value;
    snackbar.success({ message: `Stored ${name} as window.tmp` });
  };
}
